module.exports = __webpack_public_path__ + "static/media/pic2.21359a25.png";